import { keys } from '../../constants/keys.esm.js';
import { CommonGroupTag } from '../../constants/services.esm.js';
import { same } from '../../utilities/same.esm.js';

var isValidName = function isValidName(entity) {
  var _entity$value, _entity$value2;
  if (entity.subgroupTag !== CommonGroupTag.variation) {
    return true;
  }
  if (same(entity.instance, keys["default"])) {
    return false;
  }
  if (same(entity.instance, keys.custom)) {
    return false;
  }
  if (same((_entity$value = entity.value) === null || _entity$value === void 0 ? void 0 : _entity$value.name, keys["default"])) {
    return false;
  }
  if (same((_entity$value2 = entity.value) === null || _entity$value2 === void 0 ? void 0 : _entity$value2.name, keys.custom)) {
    return false;
  }
  return true;
};

export { isValidName };
//# sourceMappingURL=is-valid-name.esm.js.map
